module.exports = __webpack_public_path__ + "static/media/scyre-diamond.8edb066d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/scyre-diamond.png
// module id = 883
// module chunks = 0